import { ORG_ADMIN, ORG_OWNER } from "@xapp/stentor-api-client/dist/models/Roles";
import SecondaryNavView, { SecondaryNavItem } from "components/SecondaryNav";
import React, { FC, useMemo } from "react";
import { createPortal } from "react-dom";

export interface OrganizationSecondaryNavProps {
    readonly organizationId: string;
}

export const OrganizationSecondaryNav: FC<OrganizationSecondaryNavProps> = props => {
    const { organizationId } = props;

    const navItems = useMemo<readonly SecondaryNavItem[]>(() => [{
        name: "Overview",
        path: `/${organizationId}`
    },
    {
        name: "Apps",
        path: `/${organizationId}/apps`
    },
    {
        name: "Analytics",
        path: `/${organizationId}/analytics`
    },
    {
        name: "Members",
        path: `/${organizationId}/members`,
        showWithRoles: [ORG_ADMIN, ORG_OWNER]
    },
    {
        name: "Settings",
        path: `/${organizationId}/settings`,
        showWithRoles: [ORG_ADMIN, ORG_OWNER]
    }], [organizationId]);

    return createPortal(
        <SecondaryNavView items={navItems} navType="org" organizationId={organizationId} />,
        document.getElementById("secondary_nav_container")
    );
};
